module.exports = __webpack_public_path__ + "static/img/press10.f5ec469.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/press10.png
// module id = ceD+
// module chunks = 0